import { Box, Fade, Icon, Modal, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useState } from 'react'

const CopyLinkModal = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 360,
    height: 310,
    bgcolor: 'background.paper',
    borderRadius: '4.5px',
    boxShadow: 24,
  }

  const copyUrlToClipboard = () => {
    const currentUrl = window.location.href
    navigator.clipboard.writeText(currentUrl)
  }

  // modal logics
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    copyUrlToClipboard()
    setOpen(true)

    setTimeout(() => {
      handleClose()
    }, 3000)
  }

  const handleClose = () => setOpen(false)

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          gap: '8px',
          padding: isMobile ? '6px' : '8px 16px',
          backgroundColor: 'gray-background.main',
          border: 1,
          borderColor: 'gray-line.main',
          borderRadius: '3.5px',
          cursor: 'pointer',
        }}
        onClick={() => handleOpen()}
      >
        <Icon sx={{ fontSize: '16px' }}>ios_share</Icon>
        {!isMobile && <Typography>Copy Link</Typography>}
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Fade in={open}>
          <Box sx={style}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '20px',
                width: '100%',
                height: '100%',
                padding: '32px',
              }}
            >
              <Box
                sx={{
                  backgroundColor: 'default-background.main',
                  borderRadius: '100%',
                  padding: '40px',
                }}
              >
                <Icon sx={{ fontSize: '50px', color: 'alternate.main' }}>ios_share</Icon>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignContent: 'center',
                  gap: '6px',
                  textAlign: 'center',
                }}
              >
                <Typography variant="h4" fontWeight={600}>
                  Link copied to clipboard!
                </Typography>
                <Box>
                  <Typography sx={{ color: 'light-gray-text.main' }}>Ready to share!</Typography>
                  <Typography sx={{ color: 'light-gray-text.main' }}>
                    Paste your job link to recruit.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  )
}

export default CopyLinkModal
